/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';

import { sanitizeString } from 'bundles/account-profile/common/utils';
import SelectWithCreateNewOption from 'bundles/employability-common/components/SelectWithCreateNewOption';

import _t from 'i18n!nls/account-profile';

export const MAX_INPUT_LENGTH = 200;

type Props = {
  onSelect: (value: string) => void;
  placeholder: string;
  label?: string;
  'data-e2e'?: string;
};

type SelectionOption = {
  value: string;
  label: string;
};
const EmployerDropDown = ({ onSelect, placeholder, label, 'data-e2e': e2e }: Props) => {
  const [options, setOptions] = useState<Array<SelectionOption>>([]);
  const [error, setError] = useState<string | undefined>(undefined);

  const onSearchChange = useCallback<(...args: $TSFixMe[]) => $TSFixMe>((query: string) => {
    const sanitizedQuery = sanitizeString(query, MAX_INPUT_LENGTH);
    // Clearbit requires the query to be at least 1 character. Default to the alphabetic order if there is no query
    const queryToUse = sanitizedQuery.length > 0 ? sanitizedQuery : 'a';

    return fetch('https://autocomplete.clearbit.com/v1/companies/suggest?query=' + queryToUse)
      .then((response) => {
        if (!response.ok) throw Error(response.statusText);
        return response.json();
      })
      .then((companyOptions: Array<{ name?: string }>) => {
        const formattedOptions = companyOptions.reduce((acc, company) => {
          if (!company.name) return acc;

          return [
            ...acc,
            {
              value: company.name,
              label: company.name,
            },
          ];
        }, [] as Array<SelectionOption>);
        setOptions(formattedOptions);
        setError(undefined);
      })
      .catch(() => {
        setError(_t('Something went wrong. Please try again.'));
        setOptions([]);
      });
  }, []);

  useEffect(() => {
    onSearchChange('');
  }, [onSearchChange]);

  return (
    <span className="fs-mask" data-e2e={e2e}>
      <SelectWithCreateNewOption
        options={options}
        onSelect={onSelect}
        onSearchChange={onSearchChange}
        placeholder={placeholder}
        label={label}
        errorMessage={error}
      />
    </span>
  );
};

export default EmployerDropDown;
